import $ from 'jquery';
import 'bootstrap/js/dist/modal';
import axios from "axios";
import {makeFormData} from './general-form-maker';
import {renderErrorByResponse} from './render-response';
import {AUTH_NEW_PASSWORD, MY_GOAL} from "Core/links";

export const bindEventsToModalNewPassword = () => {
    $('#new-password-button-form').click(function () {
        const parent = $(this).parents('.modal-body');
        let data = makeFormData(parent);

        data['hash'] = $(this).attr('data-hash');

        axios.post(AUTH_NEW_PASSWORD, data)
            .then((response) => {
                window.location.href = MY_GOAL;
            })
            .catch((error) => {
                renderErrorByResponse(error.response, parent);
            });
    });
};
